class BloomFreshCommerceHeader extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.toggle = this.querySelector('[data-bf-menu-toggle]');
    this.details = [...this.querySelectorAll('.bf-commerce-header__nav-item')];

    this.toggle?.addEventListener('click', () => {
      const open = this.toggle.getAttribute('aria-expanded') !== 'true';
      this.toggle.setAttribute('aria-expanded', String(open));
      this.toggle.querySelector('.visually-hidden').textContent = open ? 'Close navigation' : 'Open navigation';
      this.toggleAttribute('data-menu-open', open);
    });

    this.details.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        this.details.forEach((other) => { if (other !== item) other.open = false; });
      });
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.closeMenus();
    });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      this.closeMenus();
      this.toggle?.focus();
    });
    this.renderUpcomingOccasions();
  }

  closeMenus() {
    this.details?.forEach((item) => { item.open = false; });
    this.removeAttribute('data-menu-open');
    this.toggle?.setAttribute('aria-expanded', 'false');
    const label = this.toggle?.querySelector('.visually-hidden');
    if (label) label.textContent = 'Open navigation';
  }

  nthWeekday(year, monthIndex, weekday, occurrence) {
    const first = new Date(year, monthIndex, 1);
    return new Date(year, monthIndex, 1 + ((weekday - first.getDay() + 7) % 7) + ((occurrence - 1) * 7));
  }

  recurringOccasions(year) {
    const laborDay = this.nthWeekday(year, 8, 1, 1);
    const grandparentsDay = new Date(year, 8, laborDay.getDate() + 6);
    const roshHashanah = { 2026: [8, 11], 2027: [9, 1], 2028: [8, 20], 2029: [8, 9], 2030: [8, 27] }[year];
    const events = [
      { name: 'Valentine’s Day', date: new Date(year, 1, 14), url: '/collections/love-romance' },
      { name: 'Mother’s Day', date: this.nthWeekday(year, 4, 0, 2), url: '/collections/all' },
      { name: 'Father’s Day', date: this.nthWeekday(year, 5, 0, 3), url: '/collections/all' },
      { name: 'Grandparents Day', date: grandparentsDay, url: '/collections/thinking-of-you' },
      { name: 'Thanksgiving', date: this.nthWeekday(year, 10, 4, 4), url: '/collections/thanksgiving-2026' },
      { name: 'Christmas Day', date: new Date(year, 11, 25), url: null }
    ];
    if (roshHashanah) events.push({ name: 'Rosh Hashanah begins', date: new Date(year, roshHashanah[0], roshHashanah[1]), url: '/collections/floral-holidays' });
    return events;
  }

  renderUpcomingOccasions() {
    const container = this.querySelector('[data-bf-upcoming-occasions]');
    if (!container) return;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const events = [];
    for (let year = today.getFullYear(); year <= today.getFullYear() + 2; year += 1) events.push(...this.recurringOccasions(year));
    const upcoming = events.filter((event) => event.date >= today).sort((a, b) => a.date - b.date).slice(0, 4);
    const formatter = new Intl.DateTimeFormat('en-US', { month: 'short' });
    container.replaceChildren(...upcoming.map((event) => {
      const link = document.createElement('a');
      if (event.url) {
        link.href = event.url;
      } else {
        link.setAttribute('aria-disabled', 'true');
        link.classList.add('bf-upcoming-occasion--disabled');
      }
      const time = document.createElement('time');
      time.dateTime = `${event.date.getFullYear()}-${String(event.date.getMonth() + 1).padStart(2, '0')}-${String(event.date.getDate()).padStart(2, '0')}`;
      const month = document.createElement('b');
      month.textContent = formatter.format(event.date).toUpperCase();
      const day = document.createElement('strong');
      day.textContent = String(event.date.getDate()).padStart(2, '0');
      const name = document.createElement('span');
      name.textContent = event.url ? event.name : `${event.name} — December 25; collection coming soon`;
      time.append(month, day);
      link.append(time, name);
      return link;
    }));
  }
}

if (!customElements.get('bloomfresh-commerce-header')) customElements.define('bloomfresh-commerce-header', BloomFreshCommerceHeader);
